export default "__VITE_ASSET__CdSEa$z3__"